module.exports = __webpack_public_path__ + "img/china.faaafd17.svg";